import { EyeOutlined, PlusCircleOutlined } from "@ant-design/icons"
import { SpecialZoomLevel } from "@react-pdf-viewer/core"
import { Button, Card } from "antd"
import React, { useState } from "react"
import { useTranslation } from "react-i18next"
import { FileViewerCached } from "~Components/fileViewer/FileViewerCached"
import { FileViewerDrawer } from "../drawer/FileViewerDrawer"
import { FileFilledIcon } from "../icons/FileFilledIcon"

export const FileViewerDetails = ({
    file,
    isDisabled,
    editRecord,
    title,
    buttonText = "action:add_document",
}: {
    file: Partial<{ name: string; url: string }>
    isDisabled: boolean
    editRecord: () => void
    title: string
    buttonText: string
}) => {
    const { t } = useTranslation()
    const [isFileViewerDrawerOpen, setIsFileViewerDrawerOpen] = useState(false)
    const [isHovered, setIsHovered] = useState(false)

    return (
        <>
            <Card
                title={
                    <div className="flex flex-col gap-4">
                        {title}
                        {file?.name ? (
                            <div
                                className="flex items-center gap-6 rounded-sm px-10 py-5 mb-10"
                                style={{ backgroundColor: "#02C2A60D", width: "fit-content", cursor: "pointer" }}
                                onClick={() => setIsFileViewerDrawerOpen(true)}
                            >
                                <FileFilledIcon />{" "}
                                <span className="font-medium overflow-hidden text-ellipsis whitespace-nowrap" style={{ width: "150px" }}>
                                    {file.name}
                                </span>
                            </div>
                        ) : null}
                    </div>
                }
            >
                {file?.url ? (
                    <div
                        className="h-380 w-320 overflow-auto "
                        onClick={() => setIsFileViewerDrawerOpen(true)}
                        onMouseEnter={() => setIsHovered(true)}
                        onMouseLeave={() => setIsHovered(false)}
                    >
                        <FileViewerCached filePath={file?.url} pdfHeight={380} enableSmoothScroll={true} showToolbar={false} defaultScale={SpecialZoomLevel.PageWidth} />

                        {/* Hover overlay mask */}
                        <div
                            className={`absolute inset-0 bg-opacity-20 flex items-center justify-center transition-opacity duration-300 ${isHovered ? "opacity-100" : "opacity-0"}`}
                            style={{ pointerEvents: "none" }}
                        >
                            <div className="flex px-20 py-10 gap-10 cursor-pointer rounded-lg" style={{ backgroundColor: "#262626B2" }}>
                                <EyeOutlined className="text-white" />
                                <span className="text-white font-medium">{t("action:view_document")}</span>
                            </div>
                        </div>
                    </div>
                ) : (
                    <div className="text-center text-gray-500 py-8">
                        <div className="el-upload__text">
                            <Button data-testid="addInvoiceInbox" disabled={isDisabled} onClick={isDisabled ? undefined : () => editRecord()}>
                                <PlusCircleOutlined />
                                {t(buttonText)}
                            </Button>
                        </div>
                    </div>
                )}
            </Card>

            <FileViewerDrawer open={isFileViewerDrawerOpen} onClose={() => setIsFileViewerDrawerOpen(false)} filePath={file?.url ?? ""} fileName={file?.name ?? ""} />
        </>
    )
}
